import { Routes, Route } from 'react-router-dom';

import Header from './Header';
import Footer from './Footer';
import PageContent from './PageContent';
import Draw from '../../modules/draw/Draw';
import About from '../../modules/about/About';
import Import from '../../modules/import/Import';

export default function AppLayout() {
  return (
    <div className="container-fluid">
      <div className="row justify-content-center">
        <Header />
        <div className="container-fluid">
          <PageContent>
            <Routes>
              <Route path="/" element={<Draw />} />
              <Route path="/about" element={<About />} />
              <Route path="/import" element={<Import />} />
            </Routes>
          </PageContent>
        </div>
        <Footer />
      </div>
    </div>
  );
}
